export default __webpack_public_path__ + "static/media/img-ovato-merchant-wallet-2.94c4e51a.png";